import React from 'react';
import UserIcon from "../../../../../gd-components/icons/user/user-icon-deprecated";

type Props = {
    option              : Option
    currentOption       : Option
    highlightedOption   : Option
    onSelectOption      : callback
}

export default function FieldUser_DeletedUsersMenuOption(props: Props) {

    const onOptionClick = (e: React.SyntheticEvent)=> {
        e.preventDefault()

        props.onSelectOption(props.option)
    }

    const classes = Classes("option", "with-icon-26", {
        "highlighted"   : props.highlightedOption?.value === props.option.value,
        "selected"      : props.currentOption?.value === props.option.value
    })

    return (
        <div className={classes}
             onClick={onOptionClick}>

            {!props.option.icon &&
                <>
                    {!props.option.value && <div className="ico i5-users"/>}
                    {props.option.value &&
                        <div className="ico">
                            <UserIcon userId={props.option.value} hint={false} size="26"/>
                        </div>}
                </>}

            <div className="label">
                {props.option.label}
            </div>
        </div>
    );
}
